module.exports = __webpack_public_path__ + "static/media/Boy.29fa2178.png";